import axios from 'axios'
import _get from 'lodash/get'
import queryString from 'query-string'

import {
    ERROR_MESSAGE_DELETING_FILE,
    ERROR_MESSAGE_DOWNLOADING_FILE,
    ERROR_MESSAGE_SAVING,
    ERROR_MESSAGE_UPLOADING_FILE,
} from '../constants'
import { reportFileUploadError } from '../helpers/sentry'
import { truncateTextMiddle } from '../helpers/strings'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const DELETE_FILE = 'DELETE_FILE'
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE'
export const RECEIVE_FILES = 'RECEIVE_FILES'
export const REMOVE_AND_DELETE_FILE = 'REMOVE_AND_DELETE_FILE'
export const REMOVE_FILE = 'REMOVE_FILE'
export const REQUEST_FILES = 'REQUEST_FILES'
export const SAVE_FILE = 'SAVE_FILE'
export const UPDATE_AND_SAVE_FILE = 'UPDATE_AND_SAVE_FILE'
export const UPLOAD_FILE = 'UPLOAD_FILE'

export const requestFiles = (selfAssessmentId) => (dispatch) => {
    dispatch({ type: REQUEST_FILES, data: { selfAssessmentId } })

    axios
        .get(`/selfassessmentfiles/?selfAssessmentId=${selfAssessmentId}`)
        .then((response) => {
            const items = _get(response, ['data'], [])
            dispatch(receiveFiles({ items, fetchSuccessful: true, isFetching: false }))
        })
        .catch((error) => {
            dispatch(receiveFiles({ fetchSuccessful: false, isFetching: false }))

            dispatch(handleRequestError(error))
        })
}

export const receiveFiles = (data) => ({ type: RECEIVE_FILES, data })

export const uploadFile = (data) => (dispatch, getState) => {
    dispatch({ type: UPLOAD_FILE, data })

    const { assessment } = getState()

    const { employmentId, file, fileSubType, fileType, filingArea, selfAssessmentId } = data

    const params = {
        selfAssessmentId: selfAssessmentId || assessment.id,
        ...(employmentId && { employmentId }),
        ...(fileSubType && { fileSubType }),
        ...(fileType && { fileType }),
        ...(filingArea && { filingArea }),
    }

    const formData = new FormData()
    formData.append('file', file)

    axios
        .post(`/selfassessmentfiles/?${queryString.stringify(params)}`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            },
        })
        .then(() => {
            const fileName = _get(file, ['name'])

            dispatch(receiveSuccessAlert(`File ${`"${truncateTextMiddle(fileName)}"`} successfully uploaded`))

            dispatch(requestFiles(selfAssessmentId || assessment.id))
        })
        .catch((error) => {
            reportFileUploadError(error, file)
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_UPLOADING_FILE }))
        })
}

export const removeAndDeleteFile =
    (data, options = {}) =>
    (dispatch) => {
        dispatch({ type: REMOVE_AND_DELETE_FILE, data })

        dispatch(removeFile(data))
        dispatch(deleteFile(data, options))
    }

export const removeFile = (data) => ({ type: REMOVE_FILE, data })

export const deleteFile =
    (data, { hideAlert = false } = {}) =>
    (dispatch) => {
        dispatch({ type: DELETE_FILE, data })

        const { id, fileName } = data

        axios
            .delete(`/selfassessmentfiles/${id}`)
            .then(() => {
                dispatch(removeFile({ id }))

                if (!hideAlert) {
                    dispatch(receiveSuccessAlert(`File ${`"${truncateTextMiddle(fileName)}"`} deleted`))
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING_FILE }))
            })
    }

export const updateAndSaveFile = (data) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_FILE, data })

    dispatch(receiveFiles({ items: [data] }))
    dispatch(saveFile(data))
}

export const saveFile = (data) => (dispatch) => {
    dispatch({ type: SAVE_FILE, data })

    const { id } = data

    axios
        .put(`/selfassessmentfiles/${id}`, data)
        .then((response) => {
            const item = _get(response, ['data'])

            if (!item) return

            dispatch(receiveFiles({ items: [item] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const downloadFile =
    (data, { onSuccess } = {}) =>
    (dispatch) => {
        dispatch({ type: DOWNLOAD_FILE, data })

        const { id } = data

        axios
            .get(`/selfassessmentfiles/${id}/downloadlink`)
            .then((response) => {
                if (response.data) {
                    window.location.assign(response.data)
                    if (onSuccess) {
                        onSuccess()
                    }
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DOWNLOADING_FILE }))
            })
    }
